export default __webpack_public_path__ + "static/media/material-ui.60a0ece0.svg";